import React, {Fragment} from 'react';
import moment from 'moment';
import 'react-select/dist/react-select.css';
import ModalComponent from "../Modal";
import AddBookingForm from "../Home/addBookingForm";
import { connect } from "react-redux";
import { getAvailableUnits } from "../../containers/Layouts/Admin/AdminCaseDetails/actions"
import { globals } from '../../../../common/constants';
import Spinner from "../Spinner";
import {getCase} from "../../containers/Layouts/Admin/AllCases/actions";
import {takeScreenShot} from "../../helpers";
import {processImageUpdate} from "../../containers/Layouts/Admin/AdminCaseDetails/helpers";

class SubcaseForm extends React.Component {
    constructor(props) {
        super(props);
        this.bridgesRef = React.createRef();
        this.state = {
            defaultDate: new Date(),
            data: {
                patient_id: this.props.caseDetails && this.props.caseDetails.patient ? this.props.caseDetails.patient.id : '',
                sending_date: null,
                date_of_return: null,
                number_of_units: 0,
                type: '',
                notes: '',
                color: '',
                signature: '',
                license: '',
                implant: '',
                implantType: '',
                implantSize: '',
                enclosedBox: [],
                implantParts: {},
                image: [],
                parent_id: null,
                bridges: this.props.bridges ? this.props.bridges : [],
            },
            validation: {
                sending_date: false,
                number_of_units: false,
                type: false,
                implant: false,
                enclosedBox: false,
                dentistSelected: false,
                date_of_return: false,
                first_name: '',
                last_name: '',
            },
            implantsPartObject: {
                1: {name: 'Impression coping ', number: 0},
                2: {name: 'Impression screw ', number: 0},
                3: {name: 'Lab analog ', number: 0},
                4: {name: 'Prosthetic screw ', number: 0},
                5: {name: 'Abutment/Ti', number: 0},
                6: {name: 'Other ', number: 0}
            },
            enclosedBoxObject: {
                1: {name: 'Impression/master model'},
                2: {name: 'Antagonist model/impression'},
                3: {name: 'Bite'},
                4: {name: 'Pre-op/temp model/impression'},
                5: {name:  'Optical scan'},
                6: { name: 'Implant parts' },
                7: { name: 'Other ' }
            },
            dentistName: this.props.caseDetails && this.props.caseDetails.dentist_id ? this.props.caseDetails.dentist_id.first_name + ' ' + this.props.caseDetails.dentist_id.last_name : '',
            modalBodyText: '',
            cancelModal: false,
            notValidDate: false,
            modalHeaderText: '',
            addBookingShow: true,
            dateNow: moment(),
            numberOfUnitsForPerDay: 0,
            moreThenAvailableUnitsModal: false,
            dateAfter10Days: moment().add(10, 'days').toDate(),
            interval: 0,
            dentistInfo: '',
            patient: '',
            hasErrorImages: false,
            isOpenLeaveModal: false,
            dateOfReturn: ''
        };
        this.handleClose = this.handleClose.bind(this);
        this.handleChangeReturnDate = this.handleChangeReturnDate.bind(this);
    }

    componentDidMount() {
        this.props.getCaseDetails(this.props.parent_id || this.state.addingBookingInfo.parent_id);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.data.date_of_return !== this.state.data.date_of_return) {
            this.props.getAvailableUnits({ date: moment(this.state.data.date_of_return).format('YYYY-MM-DD') });
        }
    }

    handleChangeSendingDate(date) {
        this.setState({
            data: {
                ...this.state.data,
                sending_date: date
            },
            validation: {
                ...this.state.validation,
                sending_date: !date
            }
        });
    }

    handleChangeReturnDate(date) {
        this.setState({
            data: {
                ...this.state.data,
                date_of_return: date
            },
            validation: {
                ...this.state.validation,
                date_of_return: false
            }
        }, () => {
            this.validateReturnDate(date);
        });
    }

    get dentistName () {
        return this.props.dashboard.patientList.dentistName || '';
    }

    get numberOfUnits() {
        return this.props.availableUnits || {}
    }

    handleChangeBookingInfo(key, value, find) {
        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                [key]:  !value,
            }
        }))
        if (key === 'enclosedBox') {
            let enclosedBox = this.state.data[key];
            const find = enclosedBox.find(item => {
                return item === value
            });

            const updateData = (find > 0) ? enclosedBox.filter(e => e !== value) : [...this.state.data[key], value];
            this.setState({
                data: {...this.state.data, [key]: updateData}
            })
        } else if (key === 'implantParts') {
            let updateData, implantParts = this.state.data[key];
            if (implantParts[value] !== undefined && !find) {
                delete implantParts[value]
                updateData = implantParts;
            } else {
                updateData = {...this.state.data[key], [(find) ? find : value]: (find) ? value : 0}
            }
            this.setState({
                data: {...this.state.data, [key]: updateData}
            })
        } else if (key === 'image') {
            const images = this.state.data.image;
            if (value.hasError) {
                this.setState({hasErrorImages: true});
            } else {
                this.setState({
                    data: {...this.state.data, image: [...images, ...value.currentImage]},
                    hasErrorImages: false
                })
            }
        } else {
            this.setState({
                data: {
                    ...this.state.data,
                    [key]: value
                }
            })
        }
    }

    validateReturnDate(returnDate) {
        let dateOfReturn;
        const dateNow = moment();
        let notValidDate = false;
        const startDate = moment(returnDate);
        const mountDiff = moment(startDate).diff(moment(dateNow), 'months', true);
        // const statusOfDay = this.getCaseStatus();
        if (startDate.day() === 0 || startDate.day() === 6) {
            notValidDate = true;
            if(!this.props.isAdmin) {
                dateOfReturn = 'Weekends are not available for booking.';
            }
        } else if (mountDiff >= 12) {
            notValidDate = true;
            if(!this.props.isAdmin) {
                dateOfReturn = 'You can make a booking only for upcoming 12 months. Please select a date within this period.';
            }
        } else if (startDate <= this.state.dateNow) {
            notValidDate = true;
            if(!this.props.isAdmin) {
                dateOfReturn = 'You are trying to select a passed date. Passed dates are not available for booking. Please select an upcoming date.';
            }
        } else if (startDate >= this.state.dateNow && startDate <= this.state.dateAfter10Days) {
            notValidDate = true;
            if(!this.props.isAdmin) {
                dateOfReturn = '10 days from the given date are unavailable for booking. Please select another date.';
            }
        }
        // else if (statusOfDay === 'pending') {
        //     notValidDate = true;
        //     if(!this.props.isAdmin) {
        //         dateOfReturn = 'No units available for this date. Please contact with administrator.';
        //     }
        // }
        else if (this.state.data.type && (this.state.data.type === 'zirconia' ? this.numberOfUnits.zirconia <= 0 : this.numberOfUnits.misc <= 0)) {
            notValidDate = true;
            if(!this.props.isAdmin) {
                dateOfReturn = 'No units available for this date. Please contact with administrator.';
            }
        }
        this.setState({
            notValidDate: notValidDate,
            addBookingShow: true,
            selectedDateKey: moment(startDate).format('YYYY-MM-DD'),
            selectedDate: moment(startDate).format('YYYY-MM-DD'),
            returnDate: moment(startDate).format('L'),
            numberOfUnitsForPerDay: this.numberOfUnits,
            dateOfReturn
        });
    }

    async handleSaveBooking() {
        const bookingInfo = this.state.data;
        const number_of_units = bookingInfo.number_of_units <= 0;
        const type = (bookingInfo.type && (bookingInfo.type.value === 'prototype' || bookingInfo.type.value === 'zirconia' || bookingInfo.type.value === 'ceramic' || bookingInfo.type.value === 'other' || bookingInfo.type.value === 'temp')) ? false : true;
        const implant = (bookingInfo.implant === '1' || bookingInfo.implant === '0') ? false : true;
        const sending_date = (bookingInfo.sending_date) ? false : true;
        const date_of_return = (bookingInfo.date_of_return) && !this.state.dateOfReturn ? false : true;
        const enclosedBox = bookingInfo.enclosedBox.length ? false : true;
        const { PENDING } = globals.PATIENT.STATUS;
        if (number_of_units || type || implant || sending_date || enclosedBox || date_of_return) {
            this.setState({
                validation: {
                    sending_date: sending_date,
                    number_of_units: number_of_units,
                    type: type,
                    implant: implant,
                    enclosedBox: enclosedBox,
                    date_of_return: date_of_return
                }
            });
        } else {
            let modalHeaderText, modalBodyText;
            const status = this.getCaseStatus();
            if (status === PENDING && !this.state.moreThenAvailableUnitsModal && !this.props.isAdmin) {
                modalHeaderText = 'Units More Than Available';
                modalBodyText = 'The number of inserted units exceeds the number of available units. The case will be pending confirmation from the lab, are you sure you want to continue ?';
                this.setState({
                    moreThenAvailableUnitsModal: true,
                    addBookingShow: false,
                    modalBodyText,
                    modalHeaderText
                });
            } else if (this.state.notValidDate && !this.state.moreThenAvailableUnitsModal) {
                modalHeaderText = 'Selected Date Is Not Available';
                modalBodyText = 'There are no available units for the selected date. Do you want to book anyway?';
                this.setState({
                    moreThenAvailableUnitsModal: true,
                    addBookingShow: false,
                    modalBodyText,
                    modalHeaderText
                });
            } else {
                await processImageUpdate(this.state, this.bridgesRef.current);
                const sendingData = {
                    patient_id: bookingInfo.patient_id || this.props.caseDetails.patient.id,
                    sending_date: moment(bookingInfo.sending_date).format('YYYY-MM-DD').toString(),
                    number_of_units: bookingInfo.number_of_units,
                    type: bookingInfo.type.value,
                    notes: bookingInfo.notes,
                    date_of_submission: moment(this.state.dateNow).format('YYYY-MM-DD').toString(),
                    date_of_return: moment(this.state.returnDate).format('YYYY-MM-DD').toString(),
                    status: this.getCaseStatus(),
                    isAdmin: true,
                    color: bookingInfo.color,
                    signature: bookingInfo.signature,
                    license: bookingInfo.license,
                    implant: bookingInfo.implant,
                    implantType: bookingInfo.implantType,
                    implantSize: bookingInfo.implantSize,
                    enclosedBox: bookingInfo.enclosedBox,
                    implantParts: bookingInfo.implantParts,
                    image: bookingInfo.image.map(({filename}) => ({filename})),
                    parent_id: this.props.parent_id || this.state.addingBookingInfo.parent_id,
                    startDate: moment().format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD'),
                    bridges:this.props.bridges,
                };
                this.props.addBooking(sendingData);
            }
        }
    }

    getCaseStatus() {
        const { SCHEDULED, PENDING } = globals.PATIENT.STATUS
        if (this.props.isAdmin) {
            return SCHEDULED;
        }
        const { CERAMIC, ZIRCONIA } = globals.CASE_TYPE;
        const caseTypeKey = [CERAMIC, ZIRCONIA].includes(this.state.data.type.value) ? ZIRCONIA : 'misc';
        return this.numberOfUnits[caseTypeKey] >= Number(this.state.data.number_of_units) ? SCHEDULED : PENDING;
    }

    removeImage(name) {
        this.setState({
            data: {
                ...this.state.data,
                image: this.state.data.image.filter(image => image.filename !== name)
            }
        });
    }


    get specialDays() {
        return this.props.dashboardData.specialDays || []
    }

    get eventList() {
        const eventList = this.props.dashboardData.events;
        if (eventList !== undefined) {
            eventList.map(item => {
                return item.startDate = item.endDate = moment(item.startDate).toDate()
            })
            return eventList;
        }
        return [];
    }

    get numberOfUnitsList() {
        return this.props.dashboardData.numberOfUnits
    }

    get patientList() {
        return this.props.dashboardData.patients
    }

    get dentistList() {
        return this.props.dashboardData.dentists
    }

    get dentistsALL() {
        return this.props.dashboardData.dentistList
    }

    handleClose() {
        if (!this.state.isOpenLeaveModal && this.state.addBookingShow) {
            this.setState({isOpenLeaveModal: !this.state.isOpenLeaveModal});
        } else {
            this.setState({
                addBookingShow: false,
                cancelModal: false,
                moreThenAvailableUnitsModal: false,
                data: {
                    ...this.state.data,
                    sending_date: null,
                    image: []
                },
                validation: {
                    sending_date: false,
                    number_of_units: false,
                    type: false,
                    implant: false,
                    enclosedBox: false,
                    dentistSelected: false,
                    patient_name: false,
                    date_of_return: false,
                    first_name: false,
                    last_name: false,
                },
                dentist: '',
                patient: '',
                isOpenLeaveModal: false
            });
            this.props.toggleSubcaseFormModal();
        }
    }

    handleStay() {
        this.setState({isOpenLeaveModal: false});
    }

    clickOutside(ref) {
        ref.cancelFocusInput();
        ref.setOpen(false);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dashboard.added === true && !this.props.dashboard.added) {
            this.setState({moreThenAvailableUnitsModal: false});
        }
        if (this.props.loadingAvailableUnits && !nextProps.loadingAvailableUnits) {
            this.validateReturnDate(this.state.data.date_of_return);
        }
    }
    
    render() {
        return (
            <div>
                <ModalComponent
                    dialogClassName="create-subcase__dialog"
                    modalHeaderStyle="modalHeaderDefault"
                    headerTitle="Create Subcase"
                    isSubcase={true}
                    modalTitleLeft={`Case ${this.props.parent_id}`}
                    modalBody={<AddBookingForm
                            disableMiscType={!this.numberOfUnits.misc}
                            disableZirconiaType={!this.numberOfUnits.zirconia}
                            minDateForSubcase={this.props.minDateForSubcase}
                            dateOfReturn={moment(this.state.dateOfReturn).format("DD/MM/YYYY")}
                            isSubcase={true}
                            onClickOutside={(ref) => this.clickOutside(ref)}
                            cancelBooking={() => this.cancelBooking()}
                            handleChange={(key, value, find = null) => this.handleChangeBookingInfo(key, value, find)}
                            handleChangeSendingDate={(sendingDate) => this.handleChangeSendingDate(sendingDate)}
                            handleChangeReturnDate={this.handleChangeReturnDate}
                            selectedDate={this.state.selectedDate}
                            selectedDateKey={this.state.selectedDateKey}
                            dateOfSubmittion={moment(this.state.dateNow).format('DD/MM/YYYY')}
                            dentist={this.props.isAdmin ? this.state.dentistName : this.dentistName}
                            dentistInfo={this.state.dentist}
                            patientList={this.patientList}
                            handleSaveBooking={() => this.handleSaveBooking()}
                            validation={this.state.validation}
                            numberOfUnits={this.state.data.number_of_units}
                            numberOfUnitsForPerDay={this.numberOfUnits}
                            listNumberOfUnits={this.numberOfUnitsList}
                            implantsPart={this.state.data.implantParts}
                            enclosedBox={this.state.data.enclosedBox}
                            implantsPartObject={this.state.implantsPartObject}
                            enclosedBoxObject={this.state.enclosedBoxObject}
                            data={this.state.data}
                            isAdmin={this.props.isAdmin}
                            hasErrorImages={this.state.hasErrorImages}
                            dentistList={this.props.isAdmin ? this.dentistList : []}
                            dentistsAll={this.dentistsALL}
                            removeImage={(fileName) => this.removeImage(fileName)}
                            specialDays={this.specialDays}
                            date_of_return={this.state.data.date_of_return}
                            vacationDays={this.props.vacationDays}
                            bridges={this.props.bridges}
                            checkedTeeth={this.props.checkedTeeth}
                            makeBridge={(from,to)=>this.props.makeBridge(from,to)}
                            bridgesRef={this.bridgesRef}
                    />
                    }
                    show={this.state.addBookingShow}
                    handleClose={() => this.handleClose()}
                    buttonText="Save"
                    buttonFunction={() => this.handleSaveBooking()}
                    addBookingForm={true}
                    saveDisabled={this.props.saveDisabled}
                />
                {
                    this.state.cancelModal &&
                    <ModalComponent
                        modalHeaderStyle="modalHeaderDefault"
                        headerTitle="Cancel Booking"
                        modalBody="Data you have inserted will be lost. Are you sure you want to leave?"
                        show={this.state.cancelModal}
                        handleClose={() => this.handleClose()}
                        buttonText="Cancel"
                        buttonFunction={() => this.handleCanceling()}
                    />
                }
                {
                    this.state.isOpenLeaveModal &&
                    <ModalComponent
                        modalHeaderStyle="modalHeaderDefault"
                        headerTitle="Close form"
                        modalBody="The case booking is not saved. Do you really want to leave?"
                        show={this.state.isOpenLeaveModal}
                        handleClose={() => this.handleStay()}
                        buttonText="Leave"
                        buttonFunction={() => this.handleClose()}
                        isLeaveModal={true}
                    />
                }
                {
                    this.state.moreThenAvailableUnitsModal &&
                    <ModalComponent
                        dialogClassName="available__modal"
                        modalHeaderStyle="modalHeaderDefault"
                        headerTitle={this.state.modalHeaderText}
                        modalBody={this.state.modalBodyText}
                        show={this.state.moreThenAvailableUnitsModal}
                        handleClose={() => this.handleClose()}
                        buttonText="Book Now"
                        buttonDisabled={this.props.saveDisabled}
                        buttonFunction={() => this.handleSaveBooking()}
                    />
                }
            </div>
        )
            ;
    }

}
const mapDispatchToProps = dispatch => {
    return {
        getAvailableUnits: (data) => { dispatch(getAvailableUnits(data)); },
        getCaseDetails: (id) => dispatch(getCase(id)),
    }
  }

const mapStateToProps = state => {
    return ({
        availableUnits: state.adminCaseDetails.availableUnits,
        loadingAvailableUnits: state.adminCaseDetails.subcaseAvailableUnitsLoading,
    });
}
  export default connect(mapStateToProps, mapDispatchToProps)(SubcaseForm);



// WEBPACK FOOTER //
// ./src/components/SubCaseForm/index.js